// extracted by mini-css-extract-plugin
export default {"image":"accountConnectedModal_image__wOK7U","stripes-animation-background-keyframes":"accountConnectedModal_stripes-animation-background-keyframes__UYN9j"};